import React from 'react'
import CyclingIcon from './cycling.svg'
import GolfIcon from './golf.svg'
import JetChartersIcon from './jet-charters.svg'
import JewelryIcon from './jewelry.svg'
import WinterSportsIcon from './winter-sports.svg'
import YachtChartersIcon from './yacht-charters.svg'
import GenericIcon from './generic.svg'
import { DepartmentType } from '#src/generated/graphql'
import classnames from 'classnames'
import styles from './styles.css'

interface DepartmentIconProps extends React.SVGAttributes<SVGSVGElement> {
  departmentType?: DepartmentType | null
  useFallback?: boolean
}

const DepartmentIcon: React.SFC<DepartmentIconProps> = ({
  departmentType,
  useFallback = false,
  strokeWidth = 1,
  className,
  ...rest
}) => {
  const classes = classnames(styles.icon, className)

  switch (departmentType) {
    case DepartmentType.CYCLING:
      return <CyclingIcon className={classes} strokeWidth={strokeWidth} {...rest} />
    case DepartmentType.GOLF:
      return <GolfIcon className={classes} strokeWidth={strokeWidth} {...rest} />
    case DepartmentType.JET_CHARTERS:
      return <JetChartersIcon className={classes} strokeWidth={strokeWidth} {...rest} />
    case DepartmentType.JEWELRY:
      return <JewelryIcon className={classes} strokeWidth={strokeWidth} {...rest} />
    case DepartmentType.WINTER_SPORTS:
      return <WinterSportsIcon className={classes} strokeWidth={strokeWidth} {...rest} />
    case DepartmentType.YACHT_CHARTERS:
      return <YachtChartersIcon className={classes} strokeWidth={strokeWidth} {...rest} />
    default:
      return <GenericIcon className={classes} strokeWidth={strokeWidth} {...rest} />
  }
}

export default DepartmentIcon
